import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "@app/gateway/services/api.service";
import { TokenService } from "@app/services/token/token.service";
// import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AppealsService {
  appealContinuanceForm;
  selectedItem;
  response;
  message;
  showMessage;
  messageWithdrawal;
  messageAppealFact;
  showMessageWithdrawal;
  showMessageAppealFact;
  loginIndvId;
  messageAppealPetition;
  showMessageAppealPetition;

  constructor(private apiService: ApiService, private token: TokenService) {}

  saveContinuance(info, controls, currentLanguage) {
    const url = "appeals/submitcontinuance";
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.loginIndvId = currentUser?.individualId;
    const saveContinuance = {}
    saveContinuance['reasonForContinuance'] = controls['reasonForContinuance'].value;
    saveContinuance['relationshipWithAppellant'] = controls['relationshipWithAppellant'].value;
    saveContinuance['appealNumber'] = info?.appealNumber;
    saveContinuance['requestDate'] = info?.requestDate;
    saveContinuance['hearingDate'] = info?.hearingDate ? info?.hearingDate : null;
    saveContinuance["userId"] = JSON.parse(sessionStorage.getItem('currentUser')).userId;
    saveContinuance["loginIndvId"] = this.loginIndvId;
    saveContinuance['lang'] = currentLanguage?.toUpperCase();
    saveContinuance['appellantSignSw'] = controls['appellantSignSW'].value;
    saveContinuance['appellantSign'] = controls['appellantSign'].value;
    saveContinuance['submittedBy'] = controls['submittedBy'].value;


      this.apiService.post(url, saveContinuance, {headers: new HttpHeaders({'pageId': 'TCAPC', 'sessionId' : this.token.getSessionId()})}, true).subscribe((res) => {
        this.response = res;

        if (res && res['returnType'].message === 'SUCCESS') {
          this.showMessage = true;
          this.message = 'SUCCESS_CONTINUANCE'
        } else if (res && res['returnType'].message === 'ERROR') {
          this.showMessage = true;
          this.message = 'ERROR_MESSAGE'
        } else {
          this.showMessage = false;
        }
      });
  }

  saveWithdrawal(info, controls, currentLanguage) {
    const url = "appeals/submitwithdrawal";
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.loginIndvId = currentUser?.individualId;
    const saveWithdrawal = {}
    saveWithdrawal['appealNumber'] = info?.appealNumber;
    saveWithdrawal['caseNumber'] = info?.caseNumber;
    saveWithdrawal['appealStatus'] = info?.appealStatusDesc;
    saveWithdrawal['appealReason'] = info?.appealReason;
    saveWithdrawal['continueBenefits'] = info?.continueBenefits;
    saveWithdrawal['phoneNumber'] = controls['phoneNumber']?.value;
    saveWithdrawal['hearingNoticeSw'] = controls['hearingNoticeSw']?.value;
    saveWithdrawal['moveOutStateSW'] = controls['moveOutStateSW']?.value;
    saveWithdrawal['validateSw'] = controls['validateSw']?.value;
    saveWithdrawal["userId"] = JSON.parse(sessionStorage.getItem('currentUser')).userId;
    saveWithdrawal["loginIndvId"] = this.loginIndvId;
    saveWithdrawal['indvId'] = info?.indvId;
    saveWithdrawal['lang'] = currentLanguage?.toUpperCase();
    saveWithdrawal['reasonForWithdrawal'] = controls['reasonForWithdrawal'].value;
    saveWithdrawal['relationshipWithAppellant'] = controls['relationshipWithAppellant'].value;
    saveWithdrawal['appellantSignSw'] = controls['appellantSignSW'].value;
    saveWithdrawal['appellantSign'] = controls['appellantSign'].value;
    saveWithdrawal['submittedBy'] = controls['submittedBy'].value;

/* add pageid */
      this.apiService.post(url, saveWithdrawal,  {headers: new HttpHeaders({'pageId': 'TCAPC', 'sessionId' : this.token.getSessionId()})}, true).subscribe((res) => {
        this.response = res;

        if (res && res['returnType'].message === 'SUCCESS') {
          this.showMessageWithdrawal = true;
          this.messageWithdrawal = 'SUCCESS_CONTINUANCE'
        } else if (res && res['returnType'].message === 'ERROR') {
          this.showMessageWithdrawal = true;
          this.messageWithdrawal = 'ERROR_MESSAGE'
        } else {
          this.showMessageWithdrawal = false;
        }
      });
  }

  saveAppealFactForm(info, controls, currentLanguage) {
    const url = "appeals/submitvfdfact";        
    const saveFactForm = {}
    saveFactForm['appealNumber'] = info?.appealNumber;
    saveFactForm['caseNumber'] = info?.caseNumber;
    saveFactForm['phoneNumber'] = controls['phoneNumber']?.value;           
    saveFactForm["userId"] = JSON.parse(sessionStorage.getItem('currentUser')).userId;    
    saveFactForm['indvId'] = info?.indvId;
    saveFactForm['lang'] = currentLanguage?.toUpperCase();
    saveFactForm['appealFactResponse'] = controls['appealFactResponse'].value;
    saveFactForm['relationshipWithAppellant'] = controls['relationshipWithAppellant'].value;    
    saveFactForm['submittedBy'] = controls['submittedBy'].value;    
      this.apiService.post(url, saveFactForm,  {headers: new HttpHeaders({'pageId': 'TCAPC', 'sessionId' : this.token.getSessionId()})}, true).subscribe((res) => {
        this.response = res;
        if (res && res['returnType'].message === 'SUCCESS') {
          this.showMessageAppealFact = true;
          this.messageAppealFact = 'SUCCESS_CONTINUANCE'
        } else if (res && res['returnType'].message === 'ERROR') {
          this.showMessageAppealFact = true;
          this.messageAppealFact = 'ERROR_MESSAGE'
        } else {
          this.messageAppealFact = false;
        }        
      });
      sessionStorage.removeItem('af_indvid');
      sessionStorage.removeItem('af_caseNumber');
      sessionStorage.removeItem('af_appealNum');
  }

   saveAppealPetitonForm(info, controls, currentLanguage) {
    const url = "appeals/submitappealpetition";        
    const saveFactForm = {}
    saveFactForm['appealNumber'] = info?.appealNumber;
    saveFactForm['caseNumber'] = info?.caseNumber;
    saveFactForm['phoneNumber'] = controls['phoneNumber']?.value;           
    saveFactForm["userId"] = JSON.parse(sessionStorage.getItem('currentUser')).userId;    
    saveFactForm['indvId'] = info?.indvId;
    saveFactForm['lang'] = currentLanguage?.toUpperCase();
    saveFactForm['appealPetitionResponse'] = controls['appealPetitionResponse'].value;
    saveFactForm['relationshipWithAppellant'] = controls['relationshipWithAppellant'].value;    
    saveFactForm['submittedBy'] = controls['submittedBy'].value;    
      this.apiService.post(url, saveFactForm,  {headers: new HttpHeaders({'pageId': 'TCAPC', 'sessionId' : this.token.getSessionId()})}, true).subscribe((res) => {
        this.response = res;
        if (res && res['returnType'].message === 'SUCCESS') {
          this.showMessageAppealPetition = true;
          this.messageAppealPetition = 'SUCCESS_CONTINUANCE'
        } else if (res && res['returnType'].message === 'ERROR') {
          this.showMessageAppealPetition = true;
          this.messageAppealPetition = 'ERROR_MESSAGE'
        } else {
          this.messageAppealPetition = false;
        }        
      });
      sessionStorage.removeItem('af_indvid');
      sessionStorage.removeItem('af_caseNumber');
      sessionStorage.removeItem('af_appealNum');
  }

}